import { Component, Input } from '@angular/core';
import { Erzeugungsanlage } from '../../domain/model/erzeugungsanlage';

@Component({
    selector: 'tnb-erzeugungsanlage-tile-view',
    templateUrl: './erzeugungsanlage-tile-view.component.html',
    styleUrls: [
        './erzeugungsanlage-tile-view.component.scss',
    ],
    standalone: false,
})
export class ErzeugungsanlageTileViewComponent {

    @Input()
    public erzeugungsanlagen: Erzeugungsanlage[];

}
